import { render, staticRenderFns } from "./ApmsRegCanteenPurchaseDetail.vue?vue&type=template&id=4479833c&scoped=true&"
import script from "./ApmsRegCanteenPurchaseDetail.vue?vue&type=script&lang=js&"
export * from "./ApmsRegCanteenPurchaseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4479833c",
  null
  
)

export default component.exports